import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import Map from './Map';

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/SortedMap.html
 */
var SortedMap = /*#__PURE__*/function (_Map) {
  _inherits(SortedMap, _Map);
  function SortedMap() {
    _classCallCheck(this, SortedMap);
    return _possibleConstructorReturn(this, _getPrototypeOf(SortedMap).apply(this, arguments));
  }
  return SortedMap;
}(Map);
export { SortedMap as default };